<template>
  <div class="app-shell home-page info-page">
    <div class="app-shell__main">
      <AppHeader />

      <main class="info-main">
        <section class="info-hero info-hero--faq">
          <div class="info-badge">FAQ</div>
          <h1 class="info-title">常见问题</h1>
          <p class="info-description">围绕解析、保存、积分和去水印限制，整理最常遇到的问题，方便你快速判断和处理。</p>
          <div class="info-summary">
            <article v-for="item in summary" :key="item.title" class="info-summary-card">
              <strong>{{ item.title }}</strong>
              <span>{{ item.text }}</span>
            </article>
          </div>
        </section>

        <section class="info-panel">
          <div class="info-section-head">
            <h2 class="section-title">问题与解答</h2>
            <p>以下内容基于网站当前能力和常见反馈整理，适合作为使用前的快速排查说明。</p>
          </div>

          <div class="info-card-list">
            <article v-for="item in faqs" :key="item.id" class="info-card">
              <div class="info-card__head">
                <div class="info-card__index">{{ item.id }}</div>
                <h3 class="info-card__title">{{ item.question }}</h3>
              </div>
              <p class="info-card__description">{{ item.answer }}</p>
              <ul class="info-points">
                <li v-for="point in item.points" :key="point">{{ point }}</li>
              </ul>
            </article>
          </div>

          <div class="info-note-panel">
            <h3>排查建议</h3>
            <ul class="info-points">
              <li>先确认链接是否复制完整，再回到首页尝试粘贴解析。</li>
              <li>如果解析成功但保存失败，优先尝试复制结果链接到浏览器下载。</li>
              <li>如果你不确定是平台问题还是内容问题，可以先换一个公开视频进行对比测试。</li>
            </ul>
          </div>
        </section>
      </main>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'CommonQuestion',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      summary: [
        { title: '解析失败', text: '先确认视频是否公开可访问，再检查当前平台是否受支持。' },
        { title: '保存失败', text: '通常与文件大小、网络环境或浏览器下载限制有关。' },
        { title: '去水印限制', text: '当前链接解析仅针对分享内容，原视频内嵌水印无法直接移除。' }
      ],
      faqs: [
        {
          id: '1',
          question: '如何成为会员？',
          answer: '进入会员中心后选择会员套餐即可开通。开通会员后，按会员权益享受对应能力与次数范围。',
          points: ['操作路径：个人中心 → 会员中心。', '开通会员后，核心工具可按会员规则使用。']
        },
        {
          id: '2',
          question: '如何获取更多积分？',
          answer: '目前主要通过购买积分套餐获取更多积分，也可以在会员中心开通会员。',
          points: ['常规路径：个人中心 → 会员中心。', '购买积分时才会增加积分数量，购买会员只增加会员时长。']
        },
        {
          id: '3',
          question: '为什么解析失败？',
          answer: '解析失败通常来自两类原因：一类是当前平台或链接暂不支持，另一类是视频内容本身受限，例如私密、不可公开访问。',
          points: ['先确认当前平台是否在支持范围内。', '确认视频是否为公开内容，是否能正常分享给他人查看。', '如果链接本身打不开，通常就无法完成解析。']
        },
        {
          id: '4',
          question: '支持哪些平台？',
          answer: '网站支持大部分主流短视频与内容平台，但并不是所有平台和内容类型都能解析，实际以页面能力为准。',
          points: ['不支持的平台，即使复制链接也无法完成解析。', '同一平台内，不同内容类型的支持情况也可能存在差异。']
        },
        {
          id: '5',
          question: '为什么保存失败？',
          answer: '保存失败通常不是解析失败，而是下载或保存环节出了问题，例如文件过大、网络超时或浏览器限制。',
          points: ['如果文件体积较大，建议复制结果链接后转到浏览器下载。', '网络较差、下载超时，也会导致保存失败。']
        },
        {
          id: '6',
          question: '为什么解析后还是有水印？',
          answer: '如果水印已经写进视频画面或图片内容里，而不是平台层叠加的分享水印，解析后通常仍会保留。',
          points: ['链接解析去掉的，通常是平台层水印。', '视频或图片内容内部的水印，需要尝试 AI 去水印等其他工具。']
        },
        {
          id: '7',
          question: '充值之后为什么没有积分？',
          answer: '这通常不是到账异常，而是购买类型不同导致的显示差异。会员增加的是时长，积分套餐才会增加积分数量。',
          points: ['购买会员：增加会员有效期，不直接增加积分。', '购买积分：才会在账号中增加可用积分数量。']
        }
      ]
    }
  }
}
</script>
